import styles from "./OurHotel.module.scss";
import cx from "classnames";

const View = ({ title, content, button }: any) => {
  return (
    <div className={styles.card}>
      {!!title && <div className={cx("ama-title", styles.title)}>{title}</div>}
      {!!content && (
        <div className={cx("ama-content", styles.content)}>{content}</div>
      )}
      {!!button && <div className={styles.checkMap}>{button}</div>}
    </div>
  );
};
export default View;
